import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import * as commonDate from 'libs/commonDate';

import { IDeptCdItemState, IInquiryCndsState, IMealsPointItemState, IPjt0101MState, IUserItemState } from '../../models/pjt/pjt0101m_model';
  
const initialState: IPjt0101MState = {
    deptCdList : [],        // 부서코드목록
    mealsPointList : [],    // 식대포인트목록
    userList: [],           // 사용자목록
    inquiryCnds : {
        baseYm : commonDate.maskDate(commonDate.getToday(), 'YYYYMM'),  // 기준년월
        deptCd : '',                                                    // 부서코드
        regYn  : 'N'                                                    // 등록여부
    },
    regAuth : false,
    pageSize : 20,      // 페이징사이즈
    current : 1,        // 현재페이지
}

export const pjt0101m_Slice = createSlice({
    name: "pjt0101m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState,
                                  deptCdList : state.deptCdList});
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setRegAuth: (state, action:PayloadAction<Boolean>) => {
            state.regAuth = action.payload;
        },
        setDeptCdList: (state, action:PayloadAction<IDeptCdItemState[]>) => {
            state.deptCdList = action.payload;
        },
        setMealsPointList: (state, action:PayloadAction<IMealsPointItemState[]>) => {
            state.mealsPointList = action.payload;
        },
        setMealsPointItem: (state, action:PayloadAction<IMealsPointItemState>) => {
            const tmpArr:IMealsPointItemState[] = state.mealsPointList.map((item) => {
                return item.empNo === action.payload.empNo ? { ...item, ...action.payload } : item;
            });

            return {
                ...state,
                mealsPointList : tmpArr
            }
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default pjt0101m_Slice.reducer;
export const Pjt0101mAction  = pjt0101m_Slice.actions;
export const Pjt0101mReducer = pjt0101m_Slice.reducer;